import React from 'react';
import { AngleSlider } from '@ark-ui/react/angle-slider';
import clsx from 'clsx';
import type { BaseInputProps } from '../../types/inputs';
import styles from './inputs.module.scss';

export interface AngleSliderInputProps extends BaseInputProps<number> {
  /** Krok ve stupních. */
  step?: number;
  /** Zobrazit textovou hodnotu úhlu. */
  showValue?: boolean;
  className?: string;
}

/**
 * Atomický úhlový posuvník (0–360°) postavený na Ark UI `AngleSlider`.
 *
 * `ids.label` pojmenuje thumb přes popisek z `<FormField />`;
 * `ids.hiddenInput` mapuje `id` bez přímého přepisu na elementu.
 */
export const AngleSliderInput: React.FC<AngleSliderInputProps> = ({
  name,
  id,
  value,
  onChange,
  onBlur,
  ref,
  disabled,
  readOnly,
  hasError,
  describedBy,
  labelId,
  testAttributes,
  step,
  showValue = true,
  className,
}) => {
  const ids = React.useMemo(
    () => ({ hiddenInput: id, label: labelId }),
    [id, labelId],
  );

  return (
  <AngleSlider.Root
    name={name}
    ids={ids}
    value={value ?? 0}
    step={step}
    disabled={disabled}
    readOnly={readOnly}
    invalid={hasError}
    onValueChange={(details) => onChange(details.value)}
    onBlur={onBlur}
    className={clsx(styles.angleRoot, className)}
  >
    <AngleSlider.Control className={styles.angleControl}>
      <AngleSlider.Thumb
        className={styles.angleThumb}
        aria-describedby={describedBy}
      />
    </AngleSlider.Control>
    {showValue && (
      <AngleSlider.ValueText className={styles.angleValueText} />
    )}
    <AngleSlider.HiddenInput ref={ref} {...testAttributes} />
  </AngleSlider.Root>
  );
};

AngleSliderInput.displayName = 'AngleSliderInput';
